import type { FC } from "react";

import Image from "next/image";

import { ArrowLeftOutlined, CloseCircleOutlined } from "@ant-design/icons";

import { Button } from "@/components/atoms/button/button";

import { Modal } from "../modal/export";

interface gtmProps {
  categoryGtm?: string;
  actionGtm?: string;
  labelGtm?: string;
}

type Props = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  url: string;
  handleCancel?: () => void;
  gtm?: gtmProps;
  handleConfirmRedirect?: () => void;
};

const ExternalRedirectModal: FC<Props> = ({
  isOpen,
  setIsOpen,
  url,
  handleCancel,
  gtm,
  handleConfirmRedirect,
}) => {
  const handleClose = () => {
    setIsOpen(false);
    if (handleCancel) handleCancel();
  };
  const handleRedirect = () => {
    setIsOpen(false);
    if (handleConfirmRedirect) handleConfirmRedirect();
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <Modal.Root open={isOpen} handleOpen={setIsOpen} maskClosable={false}>
      <header className="flex w-full justify-end">
        <button
          className="cursor-pointer border-none bg-transparent"
          onClick={handleClose}
        >
          <CloseCircleOutlined className="text-xl text-aubergine-perl-500" />
        </button>
      </header>
      <Modal.Content>
        <div className="flex flex-col gap-4">
          <div className="relative h-[252px] w-full">
            <Image src="/imgs/redirect/animals.svg" alt="redirect" fill />
          </div>
          <h2 className="mx-auto max-w-[340px] text-center text-base font-normal text-raven-500">
            Ao continuar, você será redirecionado para o link abaixo:
          </h2>
          <p className="text-center text-sm text-aubergine-perl-600">{url}</p>

          <div className="flex w-full flex-col items-center justify-center gap-4 sm:flex-row">
            <Button
              variant="secondary"
              className="order-2 h-[38px] w-[190px] cursor-pointer items-center gap-2 text-sm max-sm:w-full sm:order-1 sm:w-fit sm:text-base"
              onClick={handleClose}
            >
              <ArrowLeftOutlined />
              Cancelar e voltar
            </Button>
            <Button
              data-gtm-event-category={gtm?.categoryGtm}
              data-gtm-event-action="clique:link"
              data-gtm-event-label="continuar_link_externo"
              variant="primary"
              className="order-1 h-[38px] w-[190px] cursor-pointer items-center gap-2 text-sm max-sm:w-full sm:order-2 sm:w-fit sm:text-base"
              onClick={handleRedirect}
            >
              Continuar e abrir o link
            </Button>
          </div>
        </div>
      </Modal.Content>
    </Modal.Root>
  );
};

export default ExternalRedirectModal;
